import { Branch } from "./branch";

export class User{
   public id:number;
   public userName: string;
   public password: string;
   public passVerify: string;
   public name:string;
   public email:string;
   public cellphone:string;
   public role: number;
   public roleDescription: string;
   public enabled: boolean;
   public branches: Branch[];
   public client: string;
   
   constructor(){
      this.id = 0;
      this.userName = '';
      this.password = '';
      this.passVerify = '';
      this.name = '';
      this.email = '';
      this.cellphone = '';
      this.role = 0;
      this.roleDescription = '';
      this.enabled = true;
      this.branches = [];
      this.client = null;
   }
}

export class UserFilter{
   public name:string;
   public page: number;
   constructor(){
      this.name = '';
      this.page = 1;
   }
}

export interface IRestorePassword {
   mail: string;  
}

